import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Input2 from "../../../components/Entradas/Input2/index2";
import Button from '@mui/material/Button';
import iconWhatsapp from "../../../assets/img/whatsapp.png"
import iconEmail from "../../../assets/img/icono-email.png"
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import iconDelete from "../../../assets/img/icono-delete.png"
import Select from "../../../components/Entradas/Select";
import Swal from "sweetalert2";
import Auth from "../../../services/auth-service.js";
import { useHistory } from "react-router-dom";
import Api from "../../../services/api-service";
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useLocation } from "react-router-dom";
import {
    ContenedorTitulo,
    Main,
    Titulo,
    BotonCrear,
    BotonSiguiente2,
    ContenedorComuW,
    Icono_ContenedorComuW,
    Numero_ContenedorComuW,
    Icono2_ContenedorComuW,
    Botton2_Contenedor,
    Botton2,
    BotonRetroceder,
    NavbarTabla,
    Testing,
    Verificacion
} from "../AlertasElements";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #E8E6E2',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

let Tipo = [
    {
        value: "whatsapp",
        label: "Mensaje de Whatsapp",
    },
    {
        value: "email",
        label: "Correo Electronico",
    },
];
let codigoNumero = [
    {
        value: "593",
        label: "Ecuador(+593)",
    },
];



const MedioAlerta = () => {

    const [documento, setDocumento] = useState({});

    const [generalNumero, setGeneralNumero] = useState([]);
    const [temporizador, setTemporizador] = useState(null);
    const [generalEmail, setGeneralEmail] = useState([]);

    const [open, setOpen] = useState(false);
    const [veri, setVeri] = useState(false);
    const [veriE, setVeriE] = useState(false);
    const [botones, setBotones] = useState(false);
    const [mail, setMail] = useState("");
    const [mensajeVe, setMensajeVe] = useState("");
    const [mensajeVeE, setMensajeVeE] = useState("");
    const [selecTipo, setSelectTipo] = useState("");
    const [prefijoNumero, setPrefijoNumero] = useState("");
    const [numero, setNumero] = useState("");
    const [numbers, setNumbers] = useState([]);
    const [postEmail, setPostEmail] = useState([]);
    const query = new URLSearchParams(useLocation().search);
    const obteOrganizacion = query.get("organizacion");
    const obteLocalizacion = query.get("localizacion");

    const [isToggled, setIsToggled] = useState(false);
    const [error, setError] = useState(false);

    const handleToggle = (checked) => {
        setIsToggled(checked.target.checked);
        if (!checked.target.checked) {
            setTemporizador('');  // Resetea el valor del input cuando el toggle se desactiva
            setError(false);  // Resetea el estado de error
        }
    };

    let history = useHistory();

    function guardarAlerta() {
        const timeValue = Number(temporizador);
        documento.phones = generalNumero;
        documento.mails = generalEmail;
        documento.temporizador = timeValue
        documento.localizacion = obteLocalizacion
        Api.crearAlerta(documento).then((respues) => {
            if (respues.status == "Ok") {
                Swal.fire(`${respues.message}`, '', 'success')
                Swal.fire("Guardado exitosamente", "", "success");
                history.push(`/admin/events?organizacion=${obteOrganizacion}&localizacion=${obteLocalizacion}`);
            } else {
                Swal.fire(`${respues.message}`, '', 'error')
            }
        }, (error) => {

        })

    }

    function validacionBotones() {
        if (generalNumero.length > 0 || generalEmail.length > 0) {
            setBotones(true)
        } else {
            setBotones(false)
        }
    }

    function returnPage() {

        history.push(`/admin/messageAlert?organizacion=${obteOrganizacion}&localizacion=${obteLocalizacion}`);
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleInputChange = (event) => {
        const value = event.target.value;

        // Verifica que el valor sea un número positivo
        if (!isNaN(value) && Number(value) >= 0) {
            setTemporizador(value);
            setError(false);
        } else {
            setError(true);
        }
    }

    const handleClose2 = () => {
        setOpen(false);
        setSelectTipo("")
        setPrefijoNumero("")
        setNumero("")
        setNumbers([])
        setPostEmail([])
        setVeri(false)
        setVeriE(false)
    };
    const handleClose = () => {
        let arregloN = []
        let arregloMail = []


        setOpen(false);
        numbers.map((index) => {
            let arregloNumero = {}
            arregloNumero.number = index.number
            arregloN.push(arregloNumero)
        })
        generalNumero.map((index) => {
            let arregloNumero = {}
            arregloNumero.number = index.number
            arregloN.push(arregloNumero)
        })

        postEmail.map((index) => {
            let arregloNumero = {}
            arregloNumero = index
            arregloMail.push(arregloNumero)
        })

        generalEmail.map((index) => {
            let arregloNumero = {}
            arregloNumero = index
            arregloMail.push(arregloNumero)
        })

        setGeneralNumero(arregloN)
        setGeneralEmail(arregloMail)
        setNumbers([])
        setPostEmail([])
    };

    function eliminarPosicion(i) {
        delete (numbers[i])
        const resultado = numbers.filter(numbers => numbers != 'undefined');
        setNumbers(resultado)
    }

    function whatsappGeneral(i) {
        delete (generalNumero[i])
        const resultado = generalNumero.filter(numbers => numbers != 'undefined');
        setGeneralNumero(resultado)
    }

    function emailGeneral(i) {
        delete (generalEmail[i])
        const resultado = generalEmail.filter(numbers => numbers != 'undefined');
        setGeneralEmail(resultado)
    }

    function eliminarPosicionEmail(i) {
        delete (postEmail[i])
        const resultado = postEmail.filter(numbers => numbers != 'undefined');
        setPostEmail(resultado)
    }

    function guardarData() {
        switch (prefijoNumero) {
            case '593':
                if (numero != null && numero != "" && prefijoNumero != null && prefijoNumero != "") {
                    if (numero.length == 10) {
                        if (numero.slice(0, 1) == 0) {
                            let ta = numero.slice(1)
                            ta = `${prefijoNumero}${ta}`
                            let data = {}
                            data.number = ta

                            numbers.push(data)
                            setNumbers(numbers)
                            setPrefijoNumero("")
                            setNumero("")
                            setSelectTipo("")
                            setVeri(false)
                            // setAux(!aux)
                        }

                    } else if (numero.length == 9) {

                        setVeri(false)
                        setPrefijoNumero("")
                        setNumero("")
                        setSelectTipo("")


                    } else {
                        setVeri(true)
                        setMensajeVe("La cantidad de diguitos no es admitible")


                    }
                } else {
                    setVeri(true)
                    setMensajeVe("No puede estar vacio")



                }

                break;
            default:
        }

        // if (numero != null && numero != "" && prefijoNumero != null && prefijoNumero != "") {
        //     if (prefijoNumero == "593") {

        //     }

        //     if (numero.slice(0, 1) == 0) {
        //         let ta = numero.slice(1)
        //         ta = `${prefijoNumero}${ta}`
        //         let data = {}
        //         data.number = ta

        //         numbers.push(data)
        //         setNumbers(numbers)
        //         setPrefijoNumero("")
        //         setNumero("")
        //         setSelectTipo("")
        //         // setAux(!aux)

        //     }
        // }
    }

    function guardarEmail() {

        let expresion = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

        if (mail != null && mail != "") {
            if (expresion.test(mail)) {
                postEmail.push(mail)
                setPostEmail(postEmail)
                setMail("")
                setSelectTipo("")
                setVeriE(false)
            } else {
                setMensajeVeE("No es un correo valido")
                setVeriE(true)
            }

        } else {
            setMensajeVeE("El campo de correo no puede estar vacio")
            setVeriE(true)
        }

    }

    useEffect(() => {
        let prueba
        prueba = Auth.getAlert()
        setDocumento(prueba)
        validacionBotones()
    }, [numbers, selecTipo]);

    return (
        <>
            <Main>
                    <ContenedorTitulo>
                        <Titulo> Medios de Comunicación </Titulo>
                    </ContenedorTitulo>
                <div style={{ display: 'flex', flexDirection: 'column'}}>
                    <BotonCrear onClick={handleOpen}>Crear</BotonCrear>  


                {open ? null : <>
                    {generalNumero.map((index, i) => {
                        return (<>
                            <ContenedorComuW>
                                <Icono_ContenedorComuW src={iconWhatsapp} alt="MDN" />
                                <Numero_ContenedorComuW>{index.number}</Numero_ContenedorComuW>
                                <Icono2_ContenedorComuW onClick={() => whatsappGeneral(i)}>
                                    <DeleteIcon />
                                </Icono2_ContenedorComuW>

                            </ContenedorComuW>
                        </>)
                    })}

                    {generalEmail.map((index, i) => {
                        return (<>
                            <ContenedorComuW>
                                <Icono_ContenedorComuW src={iconEmail} alt="MDN" />
                                <Numero_ContenedorComuW>{index}</Numero_ContenedorComuW>
                                <Icono2_ContenedorComuW onClick={() => emailGeneral(i)}>
                                    <DeleteIcon />
                                </Icono2_ContenedorComuW>

                            </ContenedorComuW>
                        </>)
                    })}
                </>}

                </div>

                <Modal
                    hideBackdrop
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="child-modal-title"
                    aria-describedby="child-modal-description"
                >
                    <Box sx={{ ...style }}>

                        <h2 id="child-modal-title">Medios de comunicación</h2>
                        <p id="child-modal-description">
                            Debe seleccionar por que medio desea que le llegue las notificaciones.
                        </p>

                        <Select
                            message="Medio"
                            value={selecTipo}
                            setFunction={setSelectTipo}
                            data={Tipo}
                            id="simple-disabled"
                        ></Select>

                        {selecTipo == "whatsapp" ? <>

                            <Select
                                message="Prefijo"
                                value={prefijoNumero}
                                setFunction={setPrefijoNumero}
                                data={codigoNumero}
                                id="simple-disabled"
                            ></Select>
                            <Input2
                                message="Numero"
                                value={numero}
                                setFunction={setNumero}
                                id="outlined-disabled"
                            />
                            {veri ? <Verificacion>*{mensajeVe}</Verificacion> : null}

                            <Botton2_Contenedor>
                                <Botton2 onClick={guardarData}>
                                    Agregar
                                </Botton2>
                            </Botton2_Contenedor>

                        </> : null}

                        {selecTipo == "email" ? <>

                            <Input2
                                message="Email"
                                value={mail}
                                setFunction={setMail}
                                id="outlined-disabled"
                            />
                            <Botton2_Contenedor>
                                {veriE ? <Verificacion>*{mensajeVeE}</Verificacion> : null}
                                <Botton2 onClick={guardarEmail}>
                                    Agregar
                                </Botton2>
                            </Botton2_Contenedor>

                        </> : null}

                        {numbers <= 0 ? null : <>

                            {numbers.map((index, i) => {
                                return (
                                    <>
                                        <ContenedorComuW>
                                            <Icono_ContenedorComuW src={iconWhatsapp} alt="MDN" />
                                            <Numero_ContenedorComuW>{index.number}</Numero_ContenedorComuW>
                                            <Icono2_ContenedorComuW onClick={() => eliminarPosicion(i)}>
                                                <DeleteIcon />
                                            </Icono2_ContenedorComuW>

                                        </ContenedorComuW>

                                    </>
                                )
                            })}
                        </>}

                        {postEmail <= 0 ? null : <>

                            {postEmail.map((index, i) => {
                                return (
                                    <>
                                        <ContenedorComuW>
                                            <Icono_ContenedorComuW src={iconEmail} alt="MDN" />
                                            <Numero_ContenedorComuW>{index}</Numero_ContenedorComuW>
                                            <Icono2_ContenedorComuW onClick={() => eliminarPosicionEmail(i)}>
                                                <DeleteIcon />
                                            </Icono2_ContenedorComuW>

                                        </ContenedorComuW>


                                    </>
                                )
                            })}
                        </>}

                        <Button onClick={handleClose2}>Cancelar</Button>
                        <Button onClick={handleClose}>Guardar</Button>
                    </Box>
                </Modal>


                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', mt: 2 }}>
                    {/* Toggle Switch con texto al lado */}
                    <FormControlLabel
                        control={<Switch checked={isToggled} onChange={handleToggle} />}
                        label="Activa si deseas que la alerta no se envié inmediatamente"
                    />

                    {/* Input condicional */}
                    {isToggled && (
                        <TextField
                            label="Temporizador"
                            variant="outlined"
                            placeholder="Tiempo en min"
                            value={temporizador}
                            onChange={handleInputChange}
                            error={error}
                            helperText={error ? "Por favor ingrese un número positivo." : ""}
                            sx={{ mt: 2, width: '25%' }}
                        />
                    )}
                </Box>

                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <BotonSiguiente2 onClick={returnPage}>Atrás</BotonSiguiente2>
                    <BotonSiguiente2 onClick={guardarAlerta}>Finalizar</BotonSiguiente2>
                </div>



            </Main>
        </>
    )
}

export default MedioAlerta

